export interface IJob {
  id: string;
  percentageComplete: number;
  description: string;
}

export class Job implements IJob {
  public readonly id: string;
  public percentageComplete: number;
  public description: string;
}
